const Contacts = () => {
    return (
        <div class="col-12">
            <p class="py-3">
                Если у вас возникли вопросы, то вы можете связаться с нами:
            </p>
            <p>
                Написав нам на почту <a class='no-underline text-blue-500' href='mailto:support@ruscomtech.ru'>support@ruscomtech.ru</a>
            </p>
            <p>
                Позвонив по телефону <a class='no-underline text-blue-500' href='tel:+74956655531'>+7 (495) 665-55-31</a>
            </p>
            <p>
                Или оставить сообщение в чате на сайте
            </p>
            <p class="py-3">
                Адрес: 129626, г. Москва, проспект Мира, д.102, корп.1, комн.12
            </p>
        </div>
    )
}

export default Contacts;